import axios from 'axios';

export const api = axios.create({
  baseURL: 'https://apiws.gestaoderotas.com.br',
  //baseURL: "http://localhost:8082/",
});
